<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">Evidence Claims</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="onCloseClick()"></button>
  </div>
  <div class="modal-body">
    <div style="max-height: 60vh; overflow-y: auto;">
    <table class="table table-bordered table-sm">
      <thead class="table-dark sticky-top">
        <tr>
          <th>NDC</th>
          <th>DRUG NAME</th>
          <th>CLAIM COUNT</th>
        </tr>
      </thead>
      <tbody>
        @for (claim of data.claims; track claim.ndc) {
          <tr>
            <td>{{ claim.ndc }}</td>
            <td>{{ claim.drugName }}</td>
            <td>{{ claim.claimCount }}</td>
          </tr>
        }
      </tbody>
    </table>
    </div>
  </div>
</div>
